import { useDrfqService } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { Order } from '@paradigm/features/src/unified-rfqs/entities/drfq/orders';
import { useApi } from '@paradigm/api/src';
import { CrossButton } from '#/components/buttons/CrossButton';
import { toast } from '#/components/UnifiedRfqs/toast';
import { stopPropagation } from './common';

interface Props {
  orderId: Order['id'];
  disabled: boolean;
}

function KillOrderButton({ orderId, disabled = false }: Props) {
  const drfqService = useDrfqService();
  const [{ isLoading }, cancelOrder] = useApi(drfqService.cancelOrder);

  const handleKillOrder = () => {
    cancelOrder({ orderId }, (resp) => {
      if (!resp.ok) {
        toast(resp.message);
      }
    });
  };

  return (
    <CrossButton
      disabled={isLoading || disabled}
      onClick={stopPropagation(handleKillOrder)}
    />
  );
}

export default KillOrderButton;
